import { HStack, Text, VStack } from '@chakra-ui/react'
import { PopUpMessageContext, ScreenContext } from '@hb/react'
import { ActionButton, PageContainer, SolidActionButton, useNavigate } from '@hb/react-web'
import { auth } from '@hb/react-web/src/backend/auth'
import { applyActionCode, checkActionCode } from 'firebase/auth'
import { useCallback, useContext, useState } from 'react'

interface RevokeMultiFactorViewProps {
  oobCode: string
}

export const RevokeMultiFactorView = ({ oobCode }: RevokeMultiFactorViewProps) => {
  const { contentWidth } = useContext(ScreenContext)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { showError, showSuccess } = useContext(PopUpMessageContext)

  const handleConfirmRevoke = useCallback(async () => {
    if (!oobCode) {
      showError('No OOB code found')
      return
    }
    setLoading(true)
    try {
      await checkActionCode(auth, oobCode)
      await applyActionCode(auth, oobCode)
      auth.signOut()
      showSuccess('Multi-factor authentication revoked')
      navigate('/')
    } catch (error) {
      console.error(error)
      showError('Error revoking multi-factor authentication')
      return
    } finally {
      setLoading(false)
    }
  }, [oobCode, showError, showSuccess, navigate])

  return (
    <PageContainer>
      <VStack
        flexDir="column"
        w="100%"
        width={contentWidth}
        bg="gray.50"
        py={4}
        px={6}
        alignItems="flex-start"
        spacing={0}>
        <Text fontFamily="Hero-New" fontSize="xl" fontWeight={500} color="gray.600">
          Revoke Multi Factor
        </Text>
        <Text fontSize="lg">Are you sure you want to revoke your multi-factor authentication?</Text>
        <Text fontSize="lg">
          If you proceed, you will have to set it up again to access your account.
        </Text>
        <HStack w="100%" mt={3}>
          <ActionButton onClick={() => navigate('/')}>Cancel</ActionButton>
          <SolidActionButton ml="auto" onClick={handleConfirmRevoke} isLoading={loading}>
            Confirm and Sign Out
          </SolidActionButton>
        </HStack>
      </VStack>
    </PageContainer>
  )
}
